import type { ToBeFixed } from '@cutr/constants/utility-types';
import { usePlatformConfigStore } from '@/stores/platformConfig';

// The global read API lets call sites, including the Options API's `$platformConfig`, read without importing the store.
export const $platformConfig = {
  refresh() {
    return usePlatformConfigStore().refresh();
  },
  get() {
    return usePlatformConfigStore().platformConfig;
  },
};

const PlatformConfigPlugin = {
  install(app: ToBeFixed) {
    app.config.globalProperties.$platformConfig = $platformConfig;
  },
};

export default PlatformConfigPlugin;
